import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ShareLayout,
  ShareMain,
  ShareFilmstrip,
  TileSurface,
  MainCardNameChip,
  PresenterPlaceholder,
} from '../../styles/VideoTileGrid';
import ShareMainCard from '../ShareMainCard';
import ShareFilmstripItem from '../ShareFilmstripItem';
import FrameFooterContent from '../FrameFooterContent';
import {
  MainFooterStrip,
  PresenterIconWrap,
  PresenterTitle,
  PresenterSubtitle,
} from './style';

const ShareModeCards = ({
  isLocalUserSharing,
  mainCard,
  filmstripItems,
  getCardDisplayName,
  getShareCardKey,
  resolveUserByTileId,
  resolveDisplayNameByTileId,
  localDisplayName,
  onSelectMainTileId,
  onSelectMainCardKey,
}) => {
  const { t } = useTranslation();

  const resolveMainCardUser = () => {
    if (!mainCard) return null;
    if (mainCard.type === 'local-camera') return { self: true };
    if (mainCard.type === 'profile') return mainCard.user || null;
    if (mainCard.type === 'remote-video') return resolveUserByTileId?.(mainCard.tileId) || null;
    return null;
  };

  const shouldShowMainFooter = Boolean(mainCard) && mainCard.type !== 'content-share';
  const mainCardUser = shouldShowMainFooter ? resolveMainCardUser() : null;
  const mainCardDisplayName = getCardDisplayName(mainCard);
  const isRemoteMainCamera = mainCard?.type === 'remote-video';
  const showEmptyFilmstrip = !isLocalUserSharing && filmstripItems.length === 0;
  const displayedFilmstripItems = showEmptyFilmstrip
    ? [{ type: 'placeholder', key: 'waiting-for-participants' }]
    : filmstripItems;

  return (
    <ShareLayout>
      <ShareMain>
        {isLocalUserSharing && !mainCard ? (
        <PresenterPlaceholder>
          <PresenterIconWrap>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 3H3c-1.1 0-2 .9-2 2v10h2V5h18v10h2V5c0-1.1-.9-2-2-2zm-7 14v-4h3l-5-5-5 5h3v4h4zm-9 2h14v2H5z"/>
            </svg>
          </PresenterIconWrap>
          <PresenterTitle>{t('VideoChatV2.presenting.title')}</PresenterTitle>
          <PresenterSubtitle>{t('VideoChatV2.presenting.subtitle')}</PresenterSubtitle>
        </PresenterPlaceholder>
        ) : (
          <TileSurface>
            <ShareMainCard mainCard={mainCard} getCardDisplayName={getCardDisplayName} />
            {shouldShowMainFooter ? (
              <MainFooterStrip>
                <FrameFooterContent
                  user={mainCardUser || {}}
                  displayName={mainCardDisplayName}
                  showRemoteMutedOnly={isRemoteMainCamera}
                  showStatus={Boolean(mainCardUser)}
                />
              </MainFooterStrip>
            ) : (
              <MainCardNameChip>
                {mainCardDisplayName}
              </MainCardNameChip>
            )}
          </TileSurface>
        )}
      </ShareMain>
      {displayedFilmstripItems.length > 0 && (
        <ShareFilmstrip>
          {displayedFilmstripItems.map((item) => {
            return (
              <ShareFilmstripItem
                key={item.key || getShareCardKey(item)}
                item={item}
                getShareCardKey={getShareCardKey}
                resolveUserByTileId={resolveUserByTileId}
                resolveDisplayNameByTileId={resolveDisplayNameByTileId}
                localDisplayName={localDisplayName}
                onSelectMainTileId={onSelectMainTileId}
                onSelectMainCardKey={onSelectMainCardKey}
              />
            );
          })}
        </ShareFilmstrip>
      )}
    </ShareLayout>
  );
};

export default React.memo(ShareModeCards);
